import { normalizePageUrl } from "@/app/hooks/useCompetitionByPageUrl";
import { isDevMode } from "@/lib/env";

/**
 * Next dev serves this page at a fixed route (`/prizes/pick-your-prize-competition`), but the
 * competition's `PageUrl` in `/getactivecompetitions` may differ. Change this
 * constant to match the environment you are pointing at.
 */
export const LIFESTYLE_DEV_PAGE_URL = "/prizes/pick-your-prize-competition";

/** Page URL used to resolve the competition in Next dev; production uses `window.location`. */
export function getLifestyleDevPageUrl(): string | undefined {
  if (!isDevMode || !LIFESTYLE_DEV_PAGE_URL) return undefined;
  return normalizePageUrl(LIFESTYLE_DEV_PAGE_URL);
}
